import { useNavigate } from 'react-router-dom'

export const MISSING_URL =
  '/assembly/detail/:transferId/:docNum/missing/:missingType/:ean'

export const useGoToMissing = () => {
  const navigate = useNavigate()

  return {
    go: (
      transferId: string,
      docNum: string,
      missingType: string,
      ean: string
    ) => {
      const url = MISSING_URL.replace(':transferId', transferId)
        .replace(':missingType', missingType)
        .replace(':docNum', docNum)
        .replace(':ean', ean)
      navigate(url)
    }
  }
}
